module.exports = __webpack_public_path__ + "MarianeDesigns.webp?2924e32ad1ba32f02bb4a7005ce6470c";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MarianeDesigns.webp
// module id = 136
// module chunks = 0